
        var result = require("!!../../../../node_modules/css-loader/index.js!./user-relation.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/user-relation/user-relation.component.css
// module id = 1436
// module chunks = 0